import React, { useState } from "react";
import { toast } from "sonner";
import { Facebook, MessageCircle, Send, Link2, Twitter } from "lucide-react";
import { TID } from "@/lib/testIds";

export default function ShareButtons({ url, title, canonicalUrl, description }) {
  const [copied, setCopied] = useState(false);
  const fullUrl = canonicalUrl || (typeof window !== "undefined" ? `${window.location.origin}${url || window.location.pathname}` : url);
  const enc = encodeURIComponent;
  const shareText = description ? `${title} — ${description}` : title;

  const items = [
    { key: "facebook", label: "Facebook", tid: TID.shareFacebook, Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(fullUrl)}` },
    { key: "whatsapp", label: "WhatsApp", tid: TID.shareWhatsapp, Icon: MessageCircle, href: `https://api.whatsapp.com/send?text=${enc(`${shareText} ${fullUrl}`)}` },
    { key: "x", label: "X", tid: TID.shareX, Icon: Twitter, href: `https://twitter.com/intent/tweet?url=${enc(fullUrl)}&text=${enc(title)}` },
    { key: "telegram", label: "Telegram", tid: TID.shareTelegram, Icon: Send, href: `https://t.me/share/url?url=${enc(fullUrl)}&text=${enc(title)}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success("Enlace copiado al portapapeles");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("No se pudo copiar el enlace");
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-[11px] uppercase tracking-[0.16em] text-textgray font-semibold mr-2">Compartir:</span>
      {items.map(({ key, label, tid, Icon, href }) => (
        <a
          key={key}
          data-testid={tid}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Compartir en ${label}`}
          className="inline-flex items-center justify-center h-9 w-9 border border-softblue text-nightblue hover:bg-petroleum hover:text-white hover:border-petroleum transition-colors"
        >
          <Icon className="w-4 h-4" strokeWidth={2} />
        </a>
      ))}
      <button
        type="button"
        onClick={copy}
        data-testid={TID.shareCopy}
        aria-label="Copiar enlace"
        className={`inline-flex items-center justify-center h-9 w-9 border transition-colors ${
          copied ? "bg-watergreen border-watergreen text-nightblue" : "border-softblue text-nightblue hover:bg-petroleum hover:text-white hover:border-petroleum"
        }`}
      >
        <Link2 className="w-4 h-4" strokeWidth={2} />
      </button>
    </div>
  );
}
